<script lang="ts" setup>
import { i18n } from '@/i18n';
import InfoModal from '@/corePagesModule/components/InfoModal.vue';

// props
const props = withDefaults(
  defineProps<{
    modalState?: boolean;
  }>(),
  {
    modalState: false,
  }
);

// emits
const emits = defineEmits<{
  (e: 'save'): void;
  (e: 'cancel'): void;
  (e: 'discardAndClose'): void;
}>();

const t = i18n.t;
</script>

<template>
  <InfoModal
    :modal-state="modalState"
    icon="info"
    :back-button-label="t('キャンセル')"
    :next-button-label="t('保存')"
    :modal-width="500"
    @on-back="emits('cancel')"
    @on-next="emits('save')"
  >
    <template #title>{{ t('編集を完了') }}</template>
    <template #description>{{ t('受領用内示の編集を確定し、変更を保存します。') }}</template>
    <template #footer>
      <button class="discard-link" @click="emits('discardAndClose')">
        {{ t('保存せずに終了') }}
      </button>
    </template>
  </InfoModal>
</template>

<style lang="scss" scoped>
.discard-link {
  color: $semanticPrimary;
  font-family: Noto Sans JP;
  font-size: 14px;
  font-weight: 400;
  text-decoration: underline;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
}
</style>
